
export const apiConfig = {
    // url: "https://ucall.center/api",
    // // url: "http://127.0.0.1:8000/api",
    // wsUrl: "wss://ucall.center/ws"
    url: "https://lk.ucalll.ru/api",
    // url: "http://127.0.0.1:8000/api",
    wsUrl: "wss://lk.ucalll.ru/ws",
    asterisk_domen: "lk.ucalll.ru",
    asterisk_ws: "wss://lk.ucalll.ru/asterisk-ws",
}

// export const apiConfig = {
//     url: "http://localhost:8000/api",//"https://wa3.cheri.tech/api/dev",
//     wsUrl: "ws://127.0.0.1:1234"//wss://wa3.cheri.tech/ws/dev"
// }
